import { render, staticRenderFns } from "./ModelView.vue?vue&type=template&id=368e6622&"
import script from "./ModelView.vue?vue&type=script&lang=js&"
export * from "./ModelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports